export const SET_REGION = 'SET_REGION'
export const SET_SCHOOL = 'SET_SCHOOL'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const GET_SCHOOLS = 'GET_SCHOOLS'